export const schoolDetails = {
  name: "HOLY SEE BRIGHT ACADEMY",
  motto: "Excellence and Diligence",
  address: "No. 1, Emmanuel Street, Jeun Amawa, Masaka, Nasarawa State",
  phoneNumbers: ["+2348145406055", "+2348067237920"],
  email: "hsbrightacademy@gmail.com",
};